import TranslatedNavLink from './TranslatedNavLink';

export default TranslatedNavLink;
